

































































import {Component, Mixins, Watch} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import SelectDialogField from '@c/controls/selectControls/SelectDialogField.vue';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import {TableEditType} from '@/enums/table';

@Component({
  components: {EditDialog, SelectDialogField},
})
export default class PModuleMeasurementEditDialog extends Mixins(EditDialogMixin) {
  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  async loadMeasurements() {
    await measurementsStoreModule.fetchAll();

    if (this.data.parent.measurements)
      return measurementsStoreModule.entities.filter(
        (x: any) =>
          x.moduleType === this.data.parent.type &&
          (!this.data.parent.measurements.some((y: any) => y.measurementId == x.id) ||
            x.id === this.data.measurementId),
      );

    return [...measurementsStoreModule.entities];
  }

  @Watch('data.measurementId')
  onChooseMeasurement(measurementId: number) {
    if (!measurementId) return;

    const measurement = [...measurementsStoreModule.all].filter(m => m.id === measurementId)[0];

    if (!measurement || !this.options || this.options.type !== TableEditType.Add) return;

    this.data.topWarningBoundary = measurement.topWarningBoundary;
    this.data.topDangerBoundary = measurement.topDangerBoundary;
    this.data.topErrorBoundary = measurement.topErrorBoundary;
    this.data.bottomWarningBoundary = measurement.bottomWarningBoundary;
    this.data.bottomDangerBoundary = measurement.bottomDangerBoundary;
    this.data.bottomErrorBoundary = measurement.bottomErrorBoundary;
  }
}
